var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandCircuits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 0V3.3132L36.7952 8.61904L33.6858 11.7284L37.6594 21H44V23H32.6594L30.1858 28.7716L35.6882 34.274L23 40.618V44H21V38.1714L9.2296 33.3562L12.7832 29.8025L9.38197 23H0V21H2.36017L8.69302 7.27881L12.1975 10.7832L21 6.38197V0H23ZM23 24.5V38.4L32.3474 33.7083L23 24.5ZM21.0164 24.3978L12.7764 32.6378L20.9897 36.005L21.0164 24.3978ZM19.5801 23H11.6L14.2687 28.3081L19.5801 23ZM30.4791 23L24.4159 23.0017L28.6509 27.2367L30.4791 23ZM32.1477 13.2155L24.4 21H35.4862L32.1477 13.2155ZM9.29891 10.7131L4.56219 20.9985L19.5858 21L9.29891 10.7131ZM22.9993 5.45574L23.0074 19.5784L33.2214 9.36443L22.9993 5.45574ZM21 8.60001L13.7177 12.2592L21 19.568V8.60001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandCircuits);
export default __webpack_public_path__ + "static/media/brand-circuits.bf0d2dfd98cfad11b9d4ca7538a386c7.svg";
export { ForwardRef as ReactComponent };